
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface FormFieldProps {
  id: string;
  label: string;
  type?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  autoComplete?: string;
  autoFocus?: boolean;
  helpText?: string;
  required?: boolean;
}

const FormField = ({ 
  id, 
  label, 
  type = "text", 
  value, 
  onChange, 
  error, 
  placeholder, 
  autoComplete, 
  autoFocus,
  helpText,
  required = false
}: FormFieldProps) => {
  return (
    <div>
      <Label htmlFor={id} className="text-black font-medium">
        {label} {!required && '(Optional)'}
      </Label>
      <Input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`mt-2 h-12 ${error ? 'border-red-500' : 'border-[#cccccc]'}`}
        placeholder={placeholder}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
      />
      {helpText && (
        <p className="text-xs text-[#666666] mt-1">{helpText}</p>
      )}
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default FormField;
